import type { Dispatch, AnyAction } from 'redux';

import * as FindExpectedNotifyResultAPI from 'ab-api/web/notification/findExpectedNotifyResult';
import * as ScheduleNotificationAPI from 'ab-api/web/notification/schedule';
import * as SendManualForMultipleWorkOrdersAPI from 'ab-api/web/notification/sendManualForMultipleWorkOrders';
import * as sendManualForSingleWorkOrder from 'ab-api/web/notification/sendManualForSingleWorkOrder';

import type { ScheduleAvailableEmployeesNotification, SendUnassignedEmployeesNotification } from 'ab-requestModels/notification.requestModel';
import type ScheduleBoardTemplateNotificationRequestModel from 'ab-requestModels/scheduleBoardTemplateNotification.requestModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import { SEND_SB_TEMPLATE_FORM, SCHEDULE_SB_TEMPLATE_EMAIL } from 'af-constants/reduxForms';
import API from 'af-constants/routes/api';

export function sendTemplateNotificationSingleWO(form: sendManualForSingleWorkOrder.W_Notification_SendManualForSingleWorkOrder_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post<void>(sendManualForSingleWorkOrder.URL(), form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function sendTemplateNotificationMultipleWO(form: SendManualForMultipleWorkOrdersAPI.W_Notification_SendManualForMultipleWorkOrders_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post<void>(SendManualForMultipleWorkOrdersAPI.URL(), form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function sendSBTemplateNotification(form: ScheduleBoardTemplateNotificationRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(API.V1.NOTIFY.SEND_SB_TEMPLATE_NOTIFICATION, form, { submitting: SEND_SB_TEMPLATE_FORM });
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function scheduleForAutoNotify(form: ScheduleNotificationAPI.W_Notification_Schedule_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(ScheduleNotificationAPI.URL(), form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function scheduleUnassignedEmployeesForAutoNotify(form: ScheduleAvailableEmployeesNotification) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(API.V1.NOTIFY.SCHEDULE_UNASSIGNED_EMPLOYEES, form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function sendUnassignedEmployeesNotification(form: SendUnassignedEmployeesNotification) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(API.V1.NOTIFY.SEND_UNASSIGNED_EMPLOYEES, form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function scheduleSBForAutoNotify(form: ScheduleBoardTemplateNotificationRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(API.V1.NOTIFY.SCHEDULE_SB, form, { submitting: SCHEDULE_SB_TEMPLATE_EMAIL });
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findExpectedResultsForNotify(rm: FindExpectedNotifyResultAPI.W_Notification_FindExpectedNotifyResult_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.post<FindExpectedNotifyResultAPI.W_Notification_FindExpectedNotifyResult_VM>(FindExpectedNotifyResultAPI.URL(), rm);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
